module.exports = __webpack_public_path__ + "static/media/font_bg1.65d36340.svg";